import getJWT from './getJWT';

const isPrivilegeEqualsTo = privilege => {
  let jwt = getJWT();

  return jwt === null ? false : jwt.privileges.includes(privilege);
};

export default isPrivilegeEqualsTo;